/*=============================================== LinkifyPage ===============================================*/

import { Linkify } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

const LinkifyPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Linkify blank>
                    Hello world, visit this beautiful website
                    https://julien-sebag.com/
                </Linkify>
            ),
            code: "<Linkify blank>Hello world, visit this beautiful website https://julien-sebag.com/</Linkify>",
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "linkAs",
            intro: "Changes the HTML tag",
            type: "string",
            possibleString: "Any HTML tag",
            default: "a",
        },
        {
            subtitle: "blank",
            intro: (
                <>
                    Adds a <code>target="_blank"</code>.
                </>
            ),
            type: "boolean",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default LinkifyPage
